import { createFileRoute } from '@tanstack/react-router'
import { AdminSettings } from '@/components/admin/AdminSettings'

const VALID_SETTINGS_SECTIONS = new Set([
  'general',
  'financial',
  'receipt',
  'fiscal',
  'order-types',
  'kitchen',
  'marketing-qr',
])

// 'pra' (the old standalone "Tax Invoice Settings" tab) was merged into the
// 'fiscal' page. Alias it so existing links/bookmarks still resolve.
const SETTINGS_SECTION_ALIASES: Record<string, string> = { pra: 'fiscal' }

export const Route = createFileRoute('/admin/settings')({
  validateSearch: (raw: Record<string, unknown>) => {
    const s = raw.section
    if (typeof s !== 'string') return { section: undefined }
    const resolved = SETTINGS_SECTION_ALIASES[s] ?? s
    const section = VALID_SETTINGS_SECTIONS.has(resolved) ? resolved : undefined
    return { section }
  },
  component: function AdminSettingsRoute() {
    const { section } = Route.useSearch()
    return <AdminSettings initialUrlSection={section} />
  },
})
